/* MMLaptops Theme JS */
(function(){
  'use strict';

  /* ── NAVBAR ── */
  var nav=document.getElementById('navbar');
  var ham=document.getElementById('ham');
  var mob=document.getElementById('mob-menu');
  var icoM=document.getElementById('ico-menu');
  var icoX=document.getElementById('ico-x');

  function chkScroll(){nav.classList.toggle('scrolled',window.scrollY>24);}
  window.addEventListener('scroll',chkScroll,{passive:true});
  chkScroll();

  if(ham&&mob){
    ham.addEventListener('click',function(){
      var o=mob.classList.toggle('open');
      ham.setAttribute('aria-expanded',o);
      icoM.style.display=o?'none':'';
      icoX.style.display=o?'':'none';
    });
  }

  /* Mobile submenus */
  [['mob-brands','mob-brands-sub'],['mob-services','mob-services-sub']].forEach(function(p){
    var b=document.getElementById(p[0]),s=document.getElementById(p[1]);
    if(b&&s){b.addEventListener('click',function(){var o=s.classList.toggle('open');b.classList.toggle('open',o);});}
  });

  /* Close mobile menu on link click */
  if(mob){mob.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){mob.classList.remove('open');icoM.style.display='';icoX.style.display='none';});});}

  /* ── SCROLL REVEAL ── */
  var els=document.querySelectorAll('.reveal');
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){e.target.classList.add('on');io.unobserve(e.target);}});},{threshold:0.08,rootMargin:'0px 0px -50px 0px'});
    els.forEach(function(el){io.observe(el);});
  } else {els.forEach(function(el){el.classList.add('on');});}

  /* ── TESTIMONIALS SLIDER ── */
  var track=document.getElementById('tTrack');
  var dotsW=document.getElementById('tDots');
  var prev=document.getElementById('tPrev');
  var next=document.getElementById('tNext');
  if(track){
    var cards=track.querySelectorAll('.testi-card');
    var cur=0,timer;
    function vis(){return window.innerWidth>=1024?3:window.innerWidth>=600?2:1;}
    function max(){return Math.max(0,cards.length-vis());}
    function buildDots(){
      if(!dotsW)return;
      dotsW.innerHTML='';
      for(var i=0;i<=max();i++){
        (function(idx){
          var d=document.createElement('button');
          d.className='sl-dot'+(idx===cur?' on':'');
          d.setAttribute('aria-label','Slide '+(idx+1));
          d.addEventListener('click',function(){go(idx);reset();});
          dotsW.appendChild(d);
        })(i);
      }
    }
    function updDots(){if(dotsW)dotsW.querySelectorAll('.sl-dot').forEach(function(d,i){d.classList.toggle('on',i===cur);});}
    function go(i){
      cur=Math.max(0,Math.min(i,max()));
      var w=cards[0]?cards[0].offsetWidth:0;
      track.style.transform='translateX(-'+(cur*(w+24))+'px)';
      updDots();
      if(prev)prev.disabled=cur===0;
      if(next)next.disabled=cur>=max();
    }
    function start(){timer=setInterval(function(){go(cur>=max()?0:cur+1);},5000);}
    function reset(){clearInterval(timer);start();}
    if(prev)prev.addEventListener('click',function(){go(cur-1);reset();});
    if(next)next.addEventListener('click',function(){go(cur+1);reset();});
    buildDots();go(0);start();
    var rt;window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(function(){buildDots();go(Math.min(cur,max()));},150);});
  }

  /* ── FILTER SIDEBAR TOGGLE (mobile) ── */
  var fBtn=document.getElementById('filterBtn');
  var fSide=document.getElementById('filterSidebar');
  if(fBtn&&fSide){
    fBtn.addEventListener('click',function(){fSide.classList.toggle('hidden');});
  }

  /* ── FILTER GROUP ACCORDION ── */
  document.querySelectorAll('[data-ftoggle]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var opts=this.nextElementSibling;
      if(!opts)return;
      var isOpen=opts.style.display!=='none'&&opts.style.display!=='';
      opts.style.display=isOpen?'none':'flex';
      opts.style.flexDirection='column';
      this.classList.toggle('open',!isOpen);
    });
  });

  /* ── SORT SELECT ── */
  var sort=document.getElementById('sortSel');
  if(sort){sort.addEventListener('change',function(){var u=new URL(window.location.href);u.searchParams.set('sort_by',this.value);window.location.href=u.toString();});}

  /* ── SOCIAL LIKE BUTTONS ── */
  document.querySelectorAll('.soc-act').forEach(function(btn){
    var svg=btn.querySelector('svg');
    if(svg&&svg.getAttribute('fill')==='none'){
      btn.addEventListener('click',function(){
        var liked=svg.style.fill==='var(--red)';
        svg.style.fill=liked?'none':'var(--red)';
        svg.style.color=liked?'':'var(--red)';
        var txt=btn.childNodes[btn.childNodes.length-1];
        if(txt&&txt.nodeType===3){txt.textContent=(parseInt(txt.textContent)||(0))+(liked?-1:1);}
      });
    }
  });

})();
